/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Steps in the AI doctor intake flow.
 */
export type AIDoctorIntakeStep =
  (typeof AIDoctorIntakeStep)[keyof typeof AIDoctorIntakeStep];

export const AIDoctorIntakeStep = {
  consents: "consents",
  authentication: "authentication",
  profile: "profile",
  id_verification: "id_verification",
  renewals_chosen: "renewals_chosen",
  rfe: "rfe",
} as const;
